import axiosApi from "api/root.api";

// 公開 viewer 取物件資料，同時帶上訪客識別讓後端記錄這次閱覽（AM-185）：
// guest = 持久的 visitor id（後端據此判斷新訪客 / 回訪訪客），visitId = 這次載入的 id
export const getObjectInfo = async (uuid, { guest, visitId } = {}) => {
  const query = new URLSearchParams();
  if (guest) query.set("guest", guest);
  if (visitId) query.set("visitId", visitId);
  const queryString = query.toString();

  const urlEnd = `/scan/publish/v1/product/object/${uuid}${queryString ? `?${queryString}` : ""}`;
  const response = await axiosApi.get(urlEnd);
  const result = response.data;
  return result;
};
